import React from 'react';
import jwtDecode from 'jwt-decode';
import { Auth } from '../../firebaseInit.js';
import { observer, Provider } from 'mobx-react';
import { Responsive } from 'react-plan';
import PublicRoutes from '../../routes/Public.jsx';
import PrivateRoutes from '../../routes/Private.jsx';
import Loader from '../Loader/Loader.jsx';
import ProfileForm from '../../user/ProfileForm/ProfileForm.jsx';

class App extends React.Component {
  description: 'View on top of the Public routes.'

  constructor(props) {
    super(props);
    this.state = {
      isLogged: null
    };
  }

  componentWillMount() {
    Auth.onAuthStateChanged((user) => {
      if(user) {
        user.getToken().then( (token) => {
          const { org } = jwtDecode(token);
          this.props.stores.enrollmentStore.subscribe(user.uid);
          this.props.stores.userStore.login(user.uid).then(() => {
            this.props.stores.courseStore.loadCourses(org);
            this.setState({isLogged: true});
          });
        });
      }
      else {
        this.setState({isLogged: false});
        this.props.stores.userStore.logout();
      }

    });
  }

  render() {
    let jsxContent;
    switch (this.state.isLogged) {
      case true:
        jsxContent = <PrivateRoutes />;
        break;
      case false:
        jsxContent = <PublicRoutes />;
        break;
      case 'profile':
        jsxContent = <ProfileForm />;
        break;
      default:
        jsxContent = <Loader />;
        break;
    }
    return (
      <Provider
        courses={ this.props.stores.courseStore }
        enrollments={ this.props.stores.enrollmentStore }
        lectures={ this.props.stores.lectureStore }
        user={ this.props.stores.userStore }
      >
        <Responsive>{ jsxContent }</Responsive>
      </Provider>
    );
  }
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/js/app/App/App.jsx
 **/